import React from 'react'
import { Card, FlexView, Spinner } from 'components/common'
import { ResponsiveContainer, Tooltip, ComposedChart, XAxis, YAxis, Legend, Bar } from 'recharts'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { SafetyStockContext } from 'stores/SafetyStockStore'

const PiecesByMaterialChartCard = props => {
  const { t } = useTranslation()
  const { isLoading, chartPiecesByMaterialData } = useContext(SafetyStockContext)
  // const DEFAULT_FILTER = "INPUT - "
  // const DEFAULT_URL = "services-stock/home"
  // const DEFAULT_SEARCH = "SEARCH"

  return <Card style={{ overflow: 'hidden' }} {...props}>
    <FlexView fontSize="big" fontWeight="bold" margin="0px 0px 16px">{t('safety.chart.piecesByMaterial')}</FlexView>
    {isLoading && chartPiecesByMaterialData.length === 0 ?
      <FlexView justifyContent="center" alignItems="center" width="100%" height="100%">
        <Spinner />
      </FlexView>
      :
      <ResponsiveContainer width="99%">
        <ComposedChart data={chartPiecesByMaterialData} margin={{ top: 0 }}>
          <XAxis dataKey="nm" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="left" orientation="left" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          <Bar yAxisId="left" dataKey="qtyPlan" name={t('safety.chart.qtyPlan')} barSize={30} fill="#00a0e3" />
          <Bar yAxisId="left" dataKey="qtyActual" name={t('safety.chart.qtyActual')} barSize={30} fill="#2d2183" />
        </ComposedChart>
      </ResponsiveContainer>
    }
  </Card>
}

export default PiecesByMaterialChartCard